import * as Yup from 'yup';
import { Formik, useFormik, useFormikContext } from 'formik';
import {
  Box,
  FormHelperText,
  TextField,
  Grid,
  MenuItem,
} from '@material-ui/core';
import useMounted from '@hooks/useMounted';
import { useTranslation } from 'react-i18next';
import { useEffect, useState, useCallback } from 'react';
import axios from '@lib/axios';
import { app } from '@root/config';


const AutoSubmit = () => {
  const [timer, setTimer] = useState(undefined);
  const submitDelay = 600;
  const formikContext = useFormikContext();

  const timeoutSubmit = () => {
      clearTimeout(timer);
      setTimer(setTimeout(
        () => {formikContext.submitForm()},
        submitDelay
      ));
    };

  useEffect(() => {
    timeoutSubmit();
  }, [formikContext.values, formikContext.submitForm]);

  return null;
}

const FilterForm = ({ onSubmit, merchantId, ...props }) => {
  const mounted = useMounted();
  const { t } = useTranslation();
  const [feeRulesTypes, setFeeRulesTypes] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [feeStrategyTypes, setFeeStrategyTypes] = useState([]);

  const getFeeRulesTypes = async () => {
    await axios.get(`${app.api}/merchant/${merchantId}/fee/types`).then((response) => {
      setFeeRulesTypes(response.data);
    });
  };

  const getTerminals = async () => {
    await axios.get(`${app.api}/merchant/${merchantId}/fee/terminals`).then((response) => {
      setTerminals(response.data);
    });
  };

  const getFeeStrategyTypes = async () => {
    await axios.get(`${app.api}/merchant/${merchantId}/fee/strategies`).then((response) => {
      setFeeStrategyTypes(response.data);
    });
  };

  useEffect(() => {
    getFeeRulesTypes();
    getTerminals();
    getFeeStrategyTypes();
  }, []);

  const handleSubmit = async (values, { setErrors, setStatus, setSubmitting }) => {
    if (onSubmit) {
      onSubmit(values);
    }
  }

  const initialValues =
  {
    isActiveFeeRule: 1,
    feeRuleType: null,
    terminalId: null,
    feeStrategyType: null,
  };

  const validationSchema = Yup.object().shape({});

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit} {...props}>
          <Box m={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.isActiveFeeRule && errors.isActiveFeeRule)}
                  fullWidth
                  helperText={touched.isActiveFeeRule && errors.isActiveFeeRule}
                  label={t("isActiveFeeRule")}
                  name="isActiveFeeRule"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  select
                  value={values.isActiveFeeRule}
                  margin="normal"
                  size="small"
                >
                  <MenuItem value={null}>
                    {t("Select value")}
                  </MenuItem>
                  <MenuItem key={0} value={0}>
                    Нет
                  </MenuItem>
                  <MenuItem key={1} value={1}>
                    Да
                  </MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.feeRuleType && errors.feeRuleType)}
                  fullWidth
                  helperText={touched.feeRuleType && errors.feeRuleType}
                  label={t("feeRuleType")}
                  name="feeRuleType"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  select
                  value={values.feeRuleType}
                  margin="normal"
                  size="small"
                >
                  <MenuItem value={null}>
                    {t("Select value")}
                  </MenuItem>
                  {feeRulesTypes.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.terminalId && errors.terminalId)}
                  fullWidth
                  helperText={touched.terminalId && errors.terminalId}
                  label={t("terminal")}
                  name="terminalId"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  select
                  value={values.terminalId}
                  margin="normal"
                  size="small"
                >
                  <MenuItem value={null}>
                    {t("Select value")}
                  </MenuItem>
                  {terminals.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.feeStrategyType && errors.feeStrategyType)}
                  fullWidth
                  helperText={touched.feeStrategyType && errors.feeStrategyType}
                  label={t("feeStrategyType")}
                  name="feeStrategyType"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  select
                  value={values.feeStrategyType}
                  margin="normal"
                  size="small"
                >
                  <MenuItem value={null}>
                    {t("Select value")}
                  </MenuItem>
                  {feeStrategyTypes.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

            </Grid>
          </Box>

          {errors.submit && (
            <Box sx={{ mt: 3 }}>
              <FormHelperText error>{errors.submit}</FormHelperText>
            </Box>
          )}
          <AutoSubmit />
        </form>
      )}
    </Formik>
  );
};

export default FilterForm;
